import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiWifiOff } from "react-icons/fi";
import Loading from "../../../components/Loading";

const HOME_BACKGROUND = "#D8F3F7";
const ACCENT_COLOR = "#00908e";

interface ChatLoadingScreenProps {
  loadError: boolean;
  onRetry: () => void;
}

const ChatLoadingScreen: React.FC<ChatLoadingScreenProps> = ({
  loadError,
  onRetry,
}) => {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const hasProblem = loadError || !isOnline;

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen px-8 text-center"
      style={{ backgroundColor: HOME_BACKGROUND }}
    >
      {hasProblem ? (
        <>
          <div className="flex items-center justify-center w-20 h-20 mb-5 rounded-full bg-white">
            <FiWifiOff size={36} color={ACCENT_COLOR} />
          </div>
          <h2 className="mb-2 text-lg font-semibold text-gray-900">
            {isOnline ? "Gagal memuat ruang konsultasi" : "Koneksi internet terputus"}
          </h2>
          <p className="mb-6 text-sm text-gray-600">
            {isOnline
              ? "Kami sedang mencoba menghubungkan kembali. Pesan dari dokter tetap tersimpan."
              : "Periksa koneksi internet Anda. Ruang konsultasi akan terbuka otomatis saat koneksi kembali."}
          </p>
          <div className="flex items-center gap-2 mb-6 text-xs text-gray-500">
            <Loading size={14} color={ACCENT_COLOR} />
            <span>Mencoba menghubungkan otomatis...</span>
          </div>
          <button
            type="button"
            onClick={onRetry}
            className="w-full py-3 mb-3 font-semibold text-white rounded-full bg-morning-300"
          >
            Coba Lagi
          </button>
          <button
            type="button"
            onClick={() => navigate("/home")}
            className="w-full py-3 font-medium text-gray-600 rounded-full"
          >
            Kembali ke Beranda
          </button>
        </>
      ) : (
        <>
          <div className="mb-5">
            <Loading size={44} color={ACCENT_COLOR} />
          </div>
          <h2 className="mb-2 text-lg font-semibold text-gray-900">
            Menyiapkan ruang konsultasi
          </h2>
          <p className="text-sm text-gray-600">Mohon tunggu sebentar...</p>
        </>
      )}
    </div>
  );
};

export default ChatLoadingScreen;
